
export const categoryType = [
  { value: "", label: "Select a Category" },
  { value: "hospital", label: "Hospital" },
  { value: "labouratory", label: "Labouratory" },
  { value: "pharmacy", label: "Pharmacy" },
  { value: "clinic", label: "Clinic" },
];
